import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';
import homepageTranslations from '@/lib/homepageTranslations.json';

interface ApitherapyTeaserSectionProps {
  currentLang?: 'sl' | 'en';
}

export default function ApitherapyTeaserSection({
  currentLang = 'sl',
}: ApitherapyTeaserSectionProps) {
  const lang = currentLang === 'en' ? 'en' : 'sl';
  const content = {
    label: homepageTranslations.apitherapy.label[lang],
    title: homepageTranslations.apitherapy.title[lang],
    description: homepageTranslations.apitherapy.description[lang],
    effects: homepageTranslations.apitherapy.effects[lang],
    disclaimer: homepageTranslations.apitherapy.disclaimer[lang],
    cta: homepageTranslations.apitherapy.cta[lang],
  };

  return (
    <section className="py-32 px-6 md:px-10 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Image */}
        <div className="aspect-[4/5] card-rounded overflow-hidden bg-muted order-2 lg:order-1">
          <AppImage
            src="/images/apiterapija/cebelnjak-portret.webp"
            alt="Čebelnjak s panji in prostorom za apiterapijo"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
          />
        </div>

        {/* Text Content */}
        <div className="space-y-8 order-1 lg:order-2">
          <p className="text-xs font-bold uppercase tracking-[0.4em] text-muted-foreground">
            {content.label}
          </p>
          <h2 className="text-5xl md:text-6xl font-bold tracking-tighter leading-none">
            {content.title}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">{content.description}</p>
          <p className="text-base text-muted-foreground leading-relaxed">{content.effects}</p>
          <p className="text-sm text-muted-foreground/80 leading-relaxed">{content.disclaimer}</p>
          <Link href="/services" className="btn-primary inline-block">
            {content.cta}
          </Link>
        </div>
      </div>
    </section>
  );
}
